import React from 'react';
import { SideBar } from './sidebar';
import { getUsersByRoles, getWalletUsers } from '../../models/users';
import DataTable from 'react-data-table-component';
import i18n from '../../i18n';
import swal from 'sweetalert';
import { Modal, Spinner } from 'react-bootstrap';
import { EditUser } from './helper/edit_user';
import Select from 'react-select';
import {
  deleteWallet,
  getAllWallets,
  getWallet,
  updateWalletTransaction,
} from '../../models/wallet';
import { getLoggedUser } from '../../state/user';
import { getAllOrganization } from '../../models/organization';
import { getGroupsList } from '../../models/groups';
import FileInput from '../helpers/fileInputNew';
import {
  ArrowDown,
  Banknote,
  CreditCard,
  Download,
  ExternalLink,
  FileSpreadsheet,
  Landmark,
  Loader2,
  Pause,
  Search,
  SquarePen,
  Trash,
  TrendingUp,
  X,
} from 'lucide-react';
import PaymentCard from '../common/PaymentCard';
import SummaryCard from '../common/SummaryCard';
import HeaderBanner from '../common/HeaderBanner';
import { formatDecimal } from '../../utils/common';
import NewDropdown from '../common/NewDropDown';
import { exportTransactionsReport } from './pages/Transaction/service/transactionService';
import { toast } from 'react-toastify';
import { walletRechargeApprove } from './pages/Wallet/services/walletService';

const user = getLoggedUser();
const customStyles = {
  headCells: {
    style: {
      backgroundColor: '#F7F9FB',
      color: '#000000',
      fontSize: '14px',
    },
  },
};

const selectStyles = {
  control: (provided) => ({
    ...provided,
  }),
  option: (provided) => ({
    ...provided,
    zIndex: 2,
  }),
  singleValue: (provided) => ({
    ...provided,
  }),
  menuPortal: (provided) => ({ ...provided, zIndex: 9 }),
};

const wallet_types = {
  admin: 'Added by admin',
  sitevisit: 'Site Visit',
  enroll: 'Enroll',
  wallet_recharge: i18n.t('deposit'),
  withdraw: i18n.t('withdraw'),
  client_payment: i18n.t('client_payment'),
  client_withdraw: i18n.t('client_withdraw'),
  client_remittance: i18n.t('client_remittance'),
};
const wallet_statuses = {
  A: i18n.t('approved'),
  FA: i18n.t('finance_approved'),
  P: 'Waiting for admin approval',
  F: i18n.t('waiting_for_finance_approval'),
  W: 'Withdraw requested',
  WA: i18n.t('withdraw_request_approved_by_admin'),
  R: 'Refund Approved',
  WR: 'Withdraw Request Rejected',
};

export class UsersWallet extends React.Component {
  constructor() {
    super();
    let urlSearchParams = new URLSearchParams(window.location.search);
    let params = Object.fromEntries(urlSearchParams.entries());
    this.state = {
      loadingRowId: null,
      selected_row: null,
      update_popup: false,
      add: {},
      data: {},
      errors: {},
      is_loading: false,
      transactions: [],
      customers: [],
      all_customers: [],
      hideSidebar: false,
      totalRows: 0,
      currentPage: 1,
      input: {
        page: 1,
        limit: 15,
        customer: params && params.user ? params.user : '',
      },
      file_receipt_edit: null,
      file_fm_edit: null,
      clients: [],
      groups: [],
      credit_sum: 0,
      debit_sum: 0,
      admin_debit_sum: 0,
      balance_sum: 0,
      hold_sum: 0,
      client_due: 0,
      currency: 'OMR',
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleAddChange = this.handleAddChange.bind(this);
    this.triggerReload = this.triggerReload.bind(this);
    this.updateWalletRow = this.updateWalletRow.bind(this);
    this.updateTransactionRow = this.updateTransactionRow.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
    this.handleChangeUpdate = this.handleChangeUpdate.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
  }

  componentDidMount() {
    let input = this.state.input;
    let qstring = new URLSearchParams(input).toString();
    this.loadAllTransactions(qstring);
    this.loadCustomers();
    this.loadAllCustomers();
    this.loadAllOrganisation();
    this.loadAllGroups();
  }

  handleChangeUpdate(event) {
    let { selected_row } = this.state;
    selected_row[event.target.name] = event.target.value;
    this.setState({ selected_row });
  }

  onFileChange = (event) => {
    if (event.target.name === 'file_receipt_edit') {
      this.setState({ file_receipt_edit: event.target.files[0] });
    }
    if (event.target.name === 'file_fm_edit') {
      this.setState({ file_fm_edit: event.target.files[0] });
    }
  };

  async loadAllOrganisation() {
    const response = await getAllOrganization();
    let clients = response.data;
    this.setState({ clients });
  }

  async loadAllGroups() {
    let q = '';
    let { input } = this.state;
    if (input.client) {
      q += `organization=${input.client}`;
    }
    const response = await getGroupsList(q);
    let groups = response.data;
    this.setState({ groups });
  }

  async loadCustomers() {
    this.setState({ is_loading: true });
    const response = await getWalletUsers();
    let data = response.data;
    if (response.success) {
      const customers = data.map((item) => {
        return {
          value: item.id,
          label: item.name + ' (' + item.username + ')',
        };
      });

      this.setState({ is_loading: false });
      this.setState({ customers: customers });
    } else {
      this.setState({ is_loading: false });
    }
  }

  async loadAllCustomers() {
    this.setState({ is_loading: true });
    let q = `roles=U&is_role_wise=${true}`;
    const response = await getUsersByRoles(q);
    let data = response.data['U'];
    if (response.success) {
      const customers = data.map((item) => {
        return {
          value: item.id,
          label: item.name + ' (' + item.username + ')',
        };
      });
      this.setState({ is_loading: false });
      this.setState({ all_customers: customers });
    } else {
      this.setState({ is_loading: false });
    }
  }

  handleDownload = async (fileType) => {
    const { input } = this.state;

    const params = {
      ...Object.fromEntries(
        Object.entries(input).filter(([key]) => !['page', 'limit'].includes(key))
      ),
      fileType,
    };
    this.setState({ exportLoading: true });
    try {
      await exportTransactionsReport({
        params,
        fileType,
        fileName: 'Transaction_Report',
      });
    } finally {
      this.setState({ exportLoading: false });
    }
  };

  handleChange(event) {
    let input = this.state.input;
    input[event.target.name] = event.target.value;
    this.setState({ input });
    if (event.target.name === 'trans_type' && event.target.value === 'withdraw') {
      input['status'] = 'R';
    }
    if (event.target.name === 'client') {
      this.loadAllGroups();
    }
  }
  handleAddChange(event) {
    let { add } = this.state;
    add[event.target.name] = event.target.value;
    this.setState({ add });
  }

  handleSearch(event) {
    let input = this.state.input;
    let qstring = new URLSearchParams(input).toString();
    this.loadAllTransactions(qstring);
  }

  async loadAllTransactions(q) {
    this.setState({ is_loading: true });
    const response = await getAllWallets(q);
    let transactions = response.data;
    let meta = response.meta;
    if (response.success) {
      this.setState({ is_loading: false });
      this.setState({ transactions: transactions });
      this.setState({ totalRows: meta.total });
      this.setState({
        credit_sum: meta['credit_sum'],
        debit_sum: meta['debit_sum'],
        admin_debit_sum: meta['admin_debit_sum'],
        balance_sum: meta['balance_sum'],
        hold_sum: meta['hold_sum'],
        client_due: meta['client_due'],
      });
    } else {
      this.setState({ is_loading: false });
    }
  }

  async viewRow(id) {
    const response = await getWallet(id);
    let data = response.data;
    this.setState({ data, update_popup: true });
  }

  async updateWalletRow(row, action = 'approve') {
    if (this.state.loadingRowId === row.id) {
      toast.warning(i18n.t('already_processing'));
      return;
    }

    try {
      this.setState({
        loadingRowId: row.id,
      });

      const payload = {
        action,
        id: row.id,
      };

      const response = await walletRechargeApprove(payload);

      if (response?.success) {
        toast.success(i18n.t('approved'));
        await this.handleSearch();
      } else {
        toast.error(response?.message || i18n.t('something_went_wrong'));
      }
    } catch (error) {
      console.error(error);
      toast.error(i18n.t('something_went_wrong'));
    } finally {
      this.setState({ loadingRowId: null });
    }
  }

  handlePageChange = (page) => {
    window.scrollTo(0, 250);
    let input = this.state.input;
    let currentPage = page;
    input['page'] = currentPage;
    this.setState({ currentPage: currentPage });
    this.setState({ input: input });
    let qstring = new URLSearchParams(input).toString();
    this.setState({ query: qstring });
    this.loadAllTransactions(qstring);
  };

  async deleteRow(id) {
    const ans = await swal({
      title: i18n.t('confirm_msg_continue'),
      icon: 'warning',
      buttons: [i18n.t('cancel'), i18n.t('yes')],
      dangerMode: true,
    });
    if (!ans) {
      return;
    }

    if (ans) {
      const response = await deleteWallet(id);
      if (response.success) {
        swal(i18n.t('success'), 'User deleted', 'success', {
          buttons: false,
          timer: 2000,
        })
          .then((response) => {
            let { input } = this.state;
            let qstring = new URLSearchParams(input).toString();
            this.setState({ query: qstring });
            this.loadAllTransactions(qstring);
          })
          .catch((response) => {
            swal('Failed', 'Something went wrong', 'error');
          });
      }
    }
  }

  async updateTransactionRow() {
    let {
      id,
      user,
      bank,
      account_number,
      receipt_number,
      status,
      debit,
      credit,
      hold_amount,
      balance,
    } = this.state.selected_row;

    const formData = new FormData();
    formData.append('id', id);
    formData.append('user', user);
    formData.append('credit', credit);
    formData.append('debit', debit);
    formData.append('status', status);
    formData.append('bank', bank);
    formData.append('hold_amount', hold_amount);
    formData.append('balance', balance);
    formData.append('account_number', account_number);
    if (receipt_number && typeof receipt_number != 'undefined') {
      formData.append('receipt_number', receipt_number);
    }

    if (this.state.file_receipt_edit) {
      formData.append(
        'file_receipt',
        this.state.file_receipt_edit,
        this.state.file_receipt_edit.name
      );
    }
    if (this.state.file_fm_edit) {
      formData.append('file_fm', this.state.file_fm_edit, this.state.file_fm_edit.name);
    }
    const response = await updateWalletTransaction(formData, id);
    if (response && response.success) {
      swal(i18n.t('success'), i18n.t('approved'), 'success');
      this.handleSearch();
    }
  }

  resetForm() {
    let { add } = this.state;
    add['name'] = '';
    add['mobile'] = '';
    add['email'] = '';
    add['username'] = '';
    add['country_code'] = '+968';
    add['password'] = '';
    add['role'] = '';
    this.setState({ add: add });
  }

  testMobile(phoneNumber) {
    let reg =
      '^(+|00)(9[976]d|8[987530]d|6[987]d|5[90]d|42d|3[875]d|2[98654321]d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)(s?d){9}$';
    var OK = reg.match(phoneNumber);
    if (!OK) {
      window.alert("phone number isn't  valid");
    } else {
      window.alert('phone number is  valid');
    }
  }

  validate() {
    let input = this.state.add;
    let errors = {};
    let isValid = true;
    if (!input['user']) {
      isValid = false;
      errors['user'] = 'Please select a user.';
    }
    if (!input['credit']) {
      isValid = false;
      errors['credit'] = 'Please enter an amount.';
    }
    this.setState({
      errors: errors,
    });
    return isValid;
  }

  triggerReload(opt) {
    if (opt) {
      let { input } = this.state;
      let qstring = new URLSearchParams(input).toString();
      this.loadAllTransactions(qstring);
    }
  }
  handleHoldClick = () => {
    let { input } = this.state;
    input.trans_type = 'hold';
    this.setState({ input }, this.handleSearch);
  };

  handleWithdrawClick = () => {
    let { input } = this.state;
    input.trans_type = 'withdraw';
    input.status = 'WA';
    this.setState({ input }, this.handleSearch);
  };
  handleRefundClick = () => {
    let { input } = this.state;
    input.trans_type = 'withdraw';
    input.status = 'R';
    this.setState({ input }, this.handleSearch);
  };

  getColumns() {
    const isAdmin = user?.role === 'A';
    const isFM = user?.role === 'F';

    const columns = [
      {
        name: 'ID',
        wrap: true,
        sortable: true,
        width: '80px',
        cell: (row) => {
          const enrollUrl = row.group_id
            ? `/enrolled_users?group=${row.group_id}`
            : '/enrolled_users';

          return (
            <div className="table-row-info">
              <span className="highlight-table-value">{row.id}</span>
              <a
                href={enrollUrl}
                target="_blank"
                rel="noreferrer"
                className="table-row-info__wallet"
              >
                {i18n.t('enroll')}
                <ExternalLink size={13} />
              </a>
            </div>
          );
        },
      },
      {
        name: i18n.t('group'),
        sortable: true,
        width: '100px',
        cell: (row) => row?.group_info?.group_name || '',
      },
      {
        name: i18n.t('bidder_id'),
        sortable: true,
        width: '100px',
        cell: (row) => row.user,
      },
      {
        name: i18n.t('bidder_name'),
        width: '140px',
        cell: (row) => (row.user && row.user_info ? row.user_info.name : ''),
      },
      {
        name: i18n.t('username'),
        width: '150px',
        sortable: true,
        wrap: true,
        cell: (row) => (row.user && row.user_info ? row.user_info.username : ''),
      },
      {
        id: 6,
        name: i18n.t('email'),
        sortable: true,
        wrap: true,
        cell: (row) => (row.user && row.user_info ? row.user_info.email : ''),
      },
      {
        id: 7,
        name: i18n.t('transaction'),
        sortable: true,
        cell: (row) => row?.transaction_id,
      },
      { id: 8, name: i18n.t('deposit'), cell: (row) => row?.credit },
      { id: 9, name: i18n.t('withdraw'), cell: (row) => row?.debit },
      { id: 10, name: i18n.t('hold'), cell: (row) => row?.hold_amount },
      { id: 11, name: i18n.t('balance'), cell: (row) => row?.balance },
      {
        id: 12,
        name: `${i18n.t('client')} ${i18n.t('amount')}`,
        cell: (row) => row?.client_amount,
      },
      {
        id: 13,
        name: i18n.t('reference'),
        cell: (row) => row?.reference,
        wrap: true,
      },
      {
        id: 14,
        name: i18n.t('type'),
        wrap: true,
        cell: (row) => (row.type ? wallet_types[row.type] : ''),
      },
      {
        id: 15,
        name: i18n.t('pay_type'),
        wrap: true,
        cell: (row) => (row.method ? i18n.t(row.method) : ''),
      },
      {
        id: 16,
        name: i18n.t('status'),
        wrap: true,
        cell: (row) => (row.status ? wallet_statuses[row.status] : ''),
      },
      {
        id: 17,
        name: i18n.t('admin_approved_on'),
        wrap: true,
        cell: (row) => row?.admin_approved_on,
      },
      {
        id: 18,
        name: i18n.t('fm_approved_on'),
        wrap: true,
        cell: (row) => row?.fm_approved_on,
      },
      {
        id: 19,
        name: i18n.t('date'),
        wrap: true,
        cell: (row) => row?.created_at,
      },
      {
        id: 20,
        name: i18n.t('receipt'),
        cell: (row) =>
          row.file_receipt ? (
            <a href={row.file_receipt} target="_new" rel="noreferrer">
              {i18n.t('receipt')}
            </a>
          ) : null,
      },
      {
        id: 21,
        name: i18n.t('attachment'),
        width: '150px',
        cell: (row) => {
          const attachments = row.attatchments || [];

          return (
            <div className="d-flex flex-wrap">
              {row.file_fm && (
                <a href={row.file_fm} target="_blank" rel="noopener noreferrer">
                  {i18n.t('receipt')}
                </a>
              )}
              <br />
              {attachments.map((attachment, index) => (
                <React.Fragment key={index}>
                  <a href={attachment.document} target="_blank" rel="noopener noreferrer">
                    {i18n.t('document')} - {index + 1}
                  </a>
                  <br />
                </React.Fragment>
              ))}
            </div>
          );
        },
      },
    ];

    //  FIXED CONDITIONAL COLUMN ADDITION
    if (isAdmin || isFM) {
      columns.push({
        id: 22,
        name: i18n.t('action'),
        wrap: true,
        width: '240px',
        cell: (row) => {
          const isLoading = this.state.loadingRowId === row.id;

          if (isAdmin) {
            const buttons = [
              <button
                key="edit"
                className="btn-new btn-action btn-new--secondary"
                disabled={isLoading}
                onClick={() => this.setState({ show_edit_popup: true, selected_row: row })}
              >
                <SquarePen />
              </button>,

              <button
                key="delete"
                className="btn-new btn-action btn-new--secondary"
                disabled={isLoading}
                onClick={() => this.deleteRow(row.id)}
              >
                <Trash />
              </button>,
            ];

            if (row.status === 'P') {
              buttons.push(
                <button
                  key="approve"
                  className="btn-new btn-action"
                  disabled={isLoading}
                  onClick={() => this.updateWalletRow(row)}
                >
                  {isLoading ? (
                    <>
                      <Loader2 className="animate-spin" size={18} />
                      <span>{i18n.t('approve')}</span>
                    </>
                  ) : (
                    i18n.t('approve')
                  )}
                </button>
              );
            }

            return <div className="action-buttons">{buttons}</div>;
          }

          if (isFM && row.status === 'F') {
            return (
              <div className="action-buttons">
                <button
                  className="btn-new btn-action"
                  disabled={isLoading}
                  onClick={() => this.updateWalletRow(row)}
                >
                  {isLoading ? (
                    <>
                      <Loader2 className="animate-spin" size={18} />
                      <span>{i18n.t('approve')}</span>
                    </>
                  ) : (
                    i18n.t('approve')
                  )}
                </button>
              </div>
            );
          }

          return null;
        },
      });
    }

    return columns;
  }
  render() {
    let { transactions, customers, clients, groups, exportLoading } = this.state;

    const statusOptions = Object.entries(wallet_statuses);
    return (
      <React.Fragment>
        <HeaderBanner
          title={`${i18n.t('mzadcom')} - ${i18n.t('wallet')}`}
          // subtitle={i18n.t('track_your_successful_bid')}
        />
        <section className="sptb mt-5">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? 'col-xl-12 col-lg-12 col-md-12'
                    : 'col-xl-9 col-lg-12 col-md-12'
                }
              >
                <div className="card">
                  <div className="card-header d-flex justify-content-between">
                    <div className="d-flex w-30 w-mob-100">
                      <span
                        style={{ fontSize: '1rem', marginRight: '0.5rem' }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          });
                        }}
                      >
                        {this.state.hideSidebar && <i className="icon-size-actual"></i>}
                        {!this.state.hideSidebar && <i className="icon-size-fullscreen"></i>}
                      </span>
                    </div>

                    <div className="d-flex w-33 w-mob-100 gap-1">
                      <div className="col-sm-6 col-md-6">
                        <select
                          className="form-select textbox fs15 text-gray filter-icon "
                          data-placeholder="Select Client"
                          name="client"
                          value={this.state.input.client}
                          onChange={this.handleChange}
                        >
                          <option value="">{i18n.t('select_client')}</option>
                          {clients.length > 0 &&
                            clients.map((item) => {
                              return (
                                <option value={item.id} key={item.id}>
                                  {item.organization_name}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                      <div className="col-sm-6 col-md-6">
                        <select
                          className="form-select textbox fs15  filter-icon"
                          data-placeholder="Select Group"
                          name="group"
                          value={this.state.input.group}
                          onChange={this.handleChange}
                        >
                          <option value="">{i18n.t('select_group')}</option>
                          {groups.length > 0 &&
                            groups.map((item) => {
                              return (
                                <option value={item.id} key={item.id}>
                                  {item.group_name}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-2">
                        <div className="form-group">
                          <input
                            type="date"
                            className="form-control textbox"
                            name="fdate"
                            placeholder={i18n.t('from_date')}
                            value={this.state.input.fdate}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="form-group">
                          <input
                            type="date"
                            className="form-control textbox "
                            placeholder={i18n.t('to_date')}
                            name="tdate"
                            value={this.state.input.tdate}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="form-group">
                          <select
                            className="form-control textbox "
                            name="pay_type"
                            value={this.state.input.pay_type}
                            onChange={this.handleChange}
                          >
                            <option value="">{i18n.t('pay_type')}</option>
                            <option value="online">{i18n.t('online')}</option>
                            <option value="offline">{i18n.t('offline')}</option>
                            <option value="wallet">{i18n.t('wallet')}</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="form-group">
                          <select
                            className="form-control textbox "
                            name="trans_type"
                            value={this.state.input.trans_type}
                            onChange={this.handleChange}
                          >
                            <option value="">{i18n.t('transaction') + ' ' + i18n.t('type')}</option>
                            <option value="deposit">{i18n.t('recharge')}</option>
                            <option value="withdraw">{i18n.t('withdraw')}</option>
                            <option value="hold">{i18n.t('hold')}</option>
                            <option value="client_payment">{i18n.t('client_payment')}</option>
                            <option value="client_withdraw">{i18n.t('client_withdraw')}</option>
                            <option value="client_remittance">{i18n.t('client_remittance')}</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="">
                          <Select
                            options={customers}
                            onChange={(e) => {
                              let { input } = this.state;
                              input.customer = e.value;
                              this.setState({ input });
                            }}
                            name="customer"
                            styles={selectStyles}
                            menuPlacement="auto"
                            menuPortalTarget={document.body}
                            className="form-control textbox  p-0 border-0"
                          ></Select>
                        </div>
                      </div>
                      <div className="col-md-1">
                        <div className="d-flex gap-1">
                          {(this.state.input.customer ||
                            this.state.input.fdate ||
                            this.state.input.tdate) && (
                            <button
                              className="btn-new"
                              onClick={(e) => {
                                window.location.href = '/users-wallet';
                              }}
                            >
                              <X size={20} strokeWidth={2} />
                            </button>
                          )}
                          <button className="btn-new" onClick={this.handleSearch}>
                            <Search size={20} strokeWidth={2} />
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="">
                      <div className="payment-dashboard">
                        <PaymentCard
                          icon={CreditCard}
                          label={i18n.t('client_due')}
                          amount={formatDecimal(this.state.client_due || 0)}
                          className="payment-card-due"
                        />

                        <PaymentCard
                          icon={Pause}
                          label={i18n.t('hold')}
                          amount={formatDecimal(this.state.hold_sum || 0)}
                          className="payment-card-hold"
                          interactive={true}
                          onClick={this.handleHoldClick}
                        />

                        <PaymentCard
                          icon={ArrowDown}
                          label={i18n.t('withdraw_requested')}
                          amount={formatDecimal(this.state.admin_debit_sum)}
                          className="payment-card-withdraw"
                          interactive={true}
                          onClick={this.handleWithdrawClick}
                        />

                        <PaymentCard
                          icon={Banknote}
                          label={i18n.t('balance')}
                          amount={formatDecimal(this.state.balance_sum || 0)}
                          className="payment-card-balance"
                        />
                      </div>
                      <div className="financial-dashboard  d-flex justify-content-between align-items-center mt-2">
                        <div className="summary-cards">
                          <SummaryCard
                            icon={TrendingUp}
                            label={i18n.t('withdraw_refunded')}
                            amount={formatDecimal(this.state.debit_sum || 0)}
                            className="refund-card"
                            onClick={this.handleRefundClick}
                          />

                          <SummaryCard
                            icon={Landmark}
                            label={i18n.t('total_balance')}
                            amount={formatDecimal(
                              Number(this.state.balance_sum) + Number(this.state.hold_sum) || 0
                            )}
                            className="balance-card"
                          />
                        </div>
                        {!this.state.is_loading && transactions.length > 0 && (
                          <div className="header-action">
                            <NewDropdown
                              label={i18n.t('export')}
                              loading={exportLoading}
                              icon={Download}
                              items={[
                                {
                                  label: i18n.t('excel'),
                                  icon: FileSpreadsheet,
                                  onClick: () => this.handleDownload('excel'),
                                },
                                // {
                                //   label: i18n.t('pdf'),
                                //   icon: Printer,
                                //   onClick: () => this.handleDownload('pdf'),
                                // },
                              ]}
                            />
                          </div>
                        )}
                      </div>
                      {this.state.is_loading && (
                        <div className="text-center">
                          <Spinner animation="border" size="lg" />
                        </div>
                      )}
                      {!this.state.is_loading && transactions.length > 0 && (
                        <div className="table-responsive">
                          <div className="table-wrapper">
                            <DataTable
                              title=""
                              fixedHeader
                              columns={this.getColumns()}
                              data={transactions}
                              customStyles={customStyles}
                              highlightOnHover
                              pagination
                              paginationServer
                              paginationTotalRows={this.state.totalRows}
                              paginationPerPage={this.state.input.limit}
                              paginationDefaultPage={this.state.currentPage}
                              paginationRowsPerPageOptions={[15, 25, 50, 100]}
                              paginationComponentOptions={{
                                rowsPerPageText: i18n.t('transactions_per_page'),
                                rangeSeparatorText: i18n.t('out'),
                              }}
                              onChangeRowsPerPage={(size) => {
                                this.setState({ rows_per_page: 15 });
                                let { input } = this.state;
                                input.limit = size;
                                this.setState({ input });
                                this.handlePageChange(1);
                              }}
                              onChangePage={this.handlePageChange}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Modal
          size="lg"
          show={this.state.update_popup}
          onHide={() => this.setState({ update_popup: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">View/Edit User</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <EditUser data={this.state.data} triggerReload={this.triggerReload} />
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.show_edit_popup}
          onHide={() => {
            let { selected_row } = this.state;
            selected_row = '';
            this.setState({ show_edit_popup: false, selected_row });
          }}
          size="lg"
          dialogClassName="modal-90w"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              {i18n.t('edit')} {i18n.t('transaction')} : {this.state.selected_row?.id}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-12">
                <form id="UserUpdate" className="card-body pt-0" tabindex="500" autoComplete="off">
                  <div className="row">
                    <div className="col-md-6 col-sm-12">
                      <div className="form-group">
                        <div className="form-group">
                          <label for="form-label" className="form-label" style={{ top: 'inherit' }}>
                            {i18n.t('withdraw')} {i18n.t('amount')}
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            placeholder=""
                            name="debit"
                            value={this.state.selected_row?.debit}
                            onChange={this.handleChangeUpdate}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 col-sm-12">
                      <div className="form-group">
                        <div className="form-group">
                          <label for="form-label" className="form-label" style={{ top: 'inherit' }}>
                            {i18n.t('deposit')} {i18n.t('amount')}
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            placeholder=""
                            name="credit"
                            value={this.state.selected_row?.credit}
                            onChange={this.handleChangeUpdate}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 col-sm-12">
                      <div className="form-group">
                        <div className="form-group">
                          <label for="form-label" className="form-label" style={{ top: 'inherit' }}>
                            {i18n.t('hold')}{' '}
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            placeholder={i18n.t('hold_amount')}
                            name="hold_amount"
                            value={this.state.selected_row?.hold_amount}
                            onChange={this.handleChangeUpdate}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 col-sm-12">
                      <div className="form-group">
                        <div className="form-group">
                          <label for="form-label" className="form-label" style={{ top: 'inherit' }}>
                            {i18n.t('balance')}{' '}
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            placeholder={i18n.t('balance')}
                            name="balance"
                            value={this.state.selected_row?.balance}
                            onChange={this.handleChangeUpdate}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 col-sm-12">
                      <div className="form-group">
                        <div className="form-group">
                          <label for="form-label" className="form-label" style={{ top: 'inherit' }}>
                            {i18n.t('bank')}{' '}
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            placeholder=""
                            name="bank"
                            value={this.state.selected_row?.bank}
                            onChange={this.handleChangeUpdate}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 col-sm-12">
                      <div className="form-group">
                        <div className="form-group">
                          <label for="form-label" className="form-label" style={{ top: 'inherit' }}>
                            {i18n.t('account_number')}{' '}
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            placeholder=""
                            name="account_number"
                            value={this.state.selected_row?.account_number}
                            onChange={this.handleChangeUpdate}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 col-sm-12">
                      <div className="form-group">
                        <div className="form-group">
                          <label for="form-label" className="form-label" style={{ top: 'inherit' }}>
                            {i18n.t('receipt')}{' '}
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            placeholder={i18n.t('please_enter_receipt_number')}
                            name="receipt_number"
                            value={this.state.selected_row?.receipt_number}
                            onChange={this.handleChangeUpdate}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-12">
                      <div className="form-group">
                        <div className="form-group">
                          <label for="form-label" className="form-label" style={{ top: 'inherit' }}>
                            {i18n.t('status')}
                          </label>
                          <select
                            className="form-select textbox filter-icon"
                            data-placeholder="Select status"
                            name="status"
                            value={this.state.selected_row?.status}
                            onChange={this.handleChangeUpdate}
                          >
                            <option value="">{i18n.t('status')}</option>
                            {statusOptions.length > 0 &&
                              statusOptions.map(([key, value]) => (
                                <option value={key} key={key}>
                                  {value}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 col-sm-12">
                      <div className="form-group">
                        <div className="form-group">
                          <label for="form-label" className="form-label" style={{ top: 'inherit' }}>
                            {i18n.t('attatchment')}({i18n.t('receipt')})
                          </label>
                          <FileInput
                            wrapperClass=" pad-adjust"
                            placeholder={i18n.t('choose_file')}
                            id="file_receipt_edit"
                            name="file_receipt_edit"
                            onChange={this.onFileChange}
                            className="form-control"
                            format_url={this.state.selected_row?.file_receipt}
                            is_file_view={true}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-12">
                      <div className="form-group">
                        <div className="form-group">
                          <label for="form-label" className="form-label" style={{ top: 'inherit' }}>
                            {i18n.t('attatchment')}({i18n.t('finance')})
                          </label>
                          <FileInput
                            wrapperClass=" pad-adjust"
                            placeholder={i18n.t('choose_file')}
                            id="file_fm_edit"
                            name="file_fm_edit"
                            onChange={this.onFileChange}
                            className="form-control"
                            format_url={this.state.selected_row?.file_fm}
                            is_file_view={true}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 col-sm-12">
                      <div className="form-group">
                        <div className="form-group mb-0 mt-4 d-flex justify-content-end">
                          <button
                            type="button"
                            className="btn btn-success btn-md"
                            onClick={() => {
                              this.updateTransactionRow(false);
                            }}
                          >
                            <i className="fa fa-save" />
                            &nbsp;
                            {i18n.t('submit')}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}
